import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

export type ProfileDropdownAddIndividualAccountClickedProps = EventProps

/**
 * @event profile_dropdown_add_individual_account_clicked
 * @description Emitted when a user clicks to add an individual account from the profile dropdown.
 */
export const ProfileDropdownAddIndividualAccountClickedAnalytics =
    createAnalyticsStatic<ProfileDropdownAddIndividualAccountClickedProps>(
        ANALYTICS_EVENTS.PROFILE_DROPDOWN_ADD_INDIVIDUAL_ACCOUNT_CLICKED,
    )

export default ProfileDropdownAddIndividualAccountClickedAnalytics
